import React, { useEffect, useState } from 'react'
import { Column, TextInput } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Page from '../../../internal/Page'
import SettingsPanel from '../../../internal/SettingsPanel'
import { getText } from '../../../internal/TextLabels'
import { useToggle } from '../../../util/utility-hooks'

const InvoiceNumberSettings = ({
  nextInvoiceNumber,
  loadingInvoiceNumber,
  updateInvoiceNumber,
}) => {
  const [edit, toggleEdit] = useToggle(false)
  const [invoiceNumber, setInvoiceNumber] = useState(nextInvoiceNumber || 0)
  const [originalInvoiceNumber, setOriginalInvoiceNumber] = useState(
    nextInvoiceNumber || 0,
  )

  useEffect(() => {
    setInvoiceNumber(nextInvoiceNumber || 0)
    setOriginalInvoiceNumber(nextInvoiceNumber || 0)
  }, [nextInvoiceNumber])

  const onCancelEdit = () => {
    setInvoiceNumber(originalInvoiceNumber)
    toggleEdit()
  }
  const onSave = () => {
    updateInvoiceNumber(invoiceNumber).then(toggleEdit)
  }

  const buttons = edit
    ? [
        {
          text: getText('default.cancel'),
          action: onCancelEdit,
        },
        {
          text: getText('default.save'),
          type: 'primary',
          action: onSave,
        },
      ]
    : [
        {
          text: getText('default.edit'),
          action: toggleEdit,
        },
      ]

  return (
    <Page>
      {!loadingInvoiceNumber ? (
        <SettingsPanel
          header={getText('invoiceNumberSettings.header')}
          buttons={buttons}
        >
          <Column col6>
            <label className={midas.formLabel}>
              {getText('invoiceNumberSettings.nextInvoiceNumber')}
            </label>
          </Column>
          <Column col6>
            <TextInput
              id="next-invoice-number"
              type="number"
              value={invoiceNumber}
              onChange={e => setInvoiceNumber(e.target.value)}
              skipValidation
              disabled={!edit}
            />
          </Column>
        </SettingsPanel>
      ) : (
        <div className={midas.loading} />
      )}
    </Page>
  )
}

InvoiceNumberSettings.propTypes = {
  loadingInvoiceNumber: PropTypes.bool.isRequired,
  nextInvoiceNumber: PropTypes.number.isRequired,
  updateInvoiceNumber: PropTypes.func.isRequired,
}

export default connect()(InvoiceNumberSettings)
